import React from "react";
import { AnchorButton, Colors, Button, Intent } from "@blueprintjs/core";
import styled from "styled-components";
import { Box, quarks, Text } from "ui-components";
// import { useHistory } from 'react-router-dom'
import { useNavigate } from "react-router-dom";

import { formatLocation } from "../routes";

const NotFound = () => {
  // const history = useHistory()
  const navigate = useNavigate();
  return (
    <FullPageCenter>
      <Box flexDir="row">
        <ErrorCode>404</ErrorCode>
        <Divider />
        <Box>
          <Title>Page not found</Title>
          <Text muted mt="large" mb="small">
            Please check the URL in the address bar and try again.
          </Text>
        </Box>
      </Box>
      <Actions>
        <Button
          text="Go back home"
          intent={Intent.PRIMARY}
          style={{ marginRight: quarks.margins.small }}
          onClick={() => {
            navigate(formatLocation.review({}));
          }}
        />
      </Actions>
    </FullPageCenter>
  );
};

const FullPageCenter = styled.div`
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ErrorCode = styled.section`
  font-size: 50px;
  font-weight: ${quarks.fontWeights.bold};
  color: ${Colors.BLUE3};
`;
const Title = styled.h1`
  margin: 0;
  font-size: 50px;
  color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.LIGHT_GRAY3 : Colors.DARK_GRAY5};
`;

const Actions = styled.div`
  margin-top: ${quarks.margins.xlarge};
  margin-left: 25px;
`;

const Divider = styled.div`
  width: 2px;
  border-radius: ${quarks.borderRadii.small};
  background-color: ${({ theme: { darkMode } }) =>
    darkMode ? Colors.DARK_GRAY5 : Colors.LIGHT_GRAY3};
  margin: -10px 20px 10px 20px;
`;

export default NotFound;
